import styles from './styles.module.css';
import './index.css'
import clsx from 'clsx';
import PropTypes from 'prop-types';

function KitoCircle({ selected = false, highlighted = false, icon, tooltip, type = 'default', ...rest }) {
  return (
    <div className={styles.kitoCircle} data-selected={selected} data-highlighted={highlighted} data-type={type}>
      <span className={`${styles.kitoCircle__tooltip} kitoCircle__tooltip`}>{tooltip}</span>
      <div className={clsx(styles.kitoCircle__content, selected && styles.kitoCircle__selected)} {...rest}>
        <img src={icon} alt={tooltip} />
      </div>
    </div>
  );
}

KitoCircle.propTypes = {
  selected: PropTypes.bool,
  highlighted: PropTypes.bool,
  icon: PropTypes.node,
  tooltip: PropTypes.string,
  type: PropTypes.oneOf(['default', 'danger', 'warning']),
  rest: PropTypes.object,
};

export default KitoCircle;
